export default __webpack_public_path__ + "static/media/GR5 2B-3D-2EC.f9d0112f.jpg";